// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"cdad0c05","787":"bb5bf00c"}[chunkId] + ".chunk.js";
};